import { BatteryStatusService } from './services/battery';
import { BrowserService } from './services/browser';
import { ContactService } from './services/contact';
import { ControllerService } from './services/controller';
import { ControllerModelService } from './services/controller_model';
import { TrustedKeyStoreService } from './services/keystore';
import { LogService } from './services/log';
import { MediaboxService } from './services/mediabox';
import { MessageService } from './services/message';
import { MimeService } from './services/mime';
import { NotificationService } from './services/notification';
import { PushService } from './services/push';
import { QrCodeService } from './services/qrcode';
import { ReceiverService } from './services/receiver';
import { SettingsService } from './services/settings';
import { StateService } from './services/state';
import { StringService } from './services/string';
import { ThemeService } from './services/theme';
import { TimeoutService } from './services/timeout';
import { TitleService } from './services/title';
import { UriService } from './services/uri';
import { VersionService } from './services/version';
import { WebClientService } from './services/webclient';
angular.module('3ema.services', [])
    .service('LogService', LogService)
    .service('BatteryStatusService', BatteryStatusService)
    .service('ContactService', ContactService)
    .service('ControllerModelService', ControllerModelService)
    .service('MessageService', MessageService)
    .service('NotificationService', NotificationService)
    .service('PushService', PushService)
    .service('QrCodeService', QrCodeService)
    .service('ReceiverService', ReceiverService)
    .service('StateService', StateService)
    .service('ThemeService', ThemeService)
    .service('TimeoutService', TimeoutService)
    .service('TitleService', TitleService)
    .service('TrustedKeyStore', TrustedKeyStoreService)
    .service('WebClientService', WebClientService)
    .service('MimeService', MimeService)
    .service('BrowserService', BrowserService)
    .service('ControllerService', ControllerService)
    .service('StringService', StringService)
    .service('SettingsService', SettingsService)
    .service('MediaboxService', MediaboxService)
    .service('UriService', UriService)
    .service('VersionService', VersionService);
